import "./VendorDetail.scss";
import { MdArrowOutward } from "react-icons/md";
import { baseUrl, vendorDetail } from "../../utils/apiData";
import axios from "axios";
import { useParams } from "react-router-dom";
import LoaderCard from "../../components/loaderCard/LoaderCard";
import { useEffect, useState } from "react";
import PageLayout from "../../layouts/pagelayout/PageLayout";
import SliderInfo from "./sliderInfo/SliderInfo";
import CardStack from "./cardStack/CardStack";
import Features from "./features/Features";
import ImagesView from "./imagesView/ImagesView";
import ToolsGrid from "./toolsGrid/ToolsGrid";
import WOW from "wow.js";

const VendorDetail = () => {
  const [loader, setLoader] = useState(false);
  const [vendor, setVendor] = useState({});

  const { slug } = useParams();

  useEffect(() => {
    const wow = new WOW();
    wow.init();
  }, []);

  const vendorDetailApi = async () => {
    setLoader(true);
    try {
      const res = await axios.post(`${baseUrl}/${vendorDetail}`, { slug });
      if (res?.data?.success) {
        setVendor(res?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
    setLoader(false);
  };

  useEffect(() => {
    vendorDetailApi();
  }, []);

  return loader ? (
    <LoaderCard />
  ) : (
    <PageLayout>
      <section className="vendor_detail_landing p_bottom">
        <div className="overlay"></div>
        <div className="content_wrap p_top p_bottom">
          <div className="intro">
            <div className="left">
              <div className="pill_wrap">
                <p className="t-16">{vendor?.category?.category_name || "-"}</p>
              </div>
              <h3>{vendor?.name || "-"}</h3>
              <div className="logo_wrap">
                <img src={`${baseUrl}/${vendor?.image}`} alt="Logo" />
              </div>
            </div>
            <div className="right">
              <p>{vendor?.small_description}</p>
            </div>
          </div>

          <div className="floating_card">
            <h3>Visit Vendor Website :</h3>

            <a href={vendor?.vendor_website || "-"} target="_blank">
              Learn More <MdArrowOutward />
            </a>
          </div>
        </div>
      </section>
      <div className="p_top bg_primary"></div>

      {/* Features */}
      {vendor?.features?.length > 0 && <Features dataList={vendor?.features} />}

      {/* Tools */}
      {vendor?.tools?.length > 0 && <ToolsGrid dataList={vendor?.tools} />}

      {vendor?.tools?.length > 0 && (
        <div className="p_bottom" style={{ background: "white" }}></div>
      )}

      {/* Solutions */}
      {vendor?.offers?.length > 0 && <CardStack dataList={vendor?.offers} />}

      {/* Verticles */}
      {vendor?.verticals?.length > 0 && (
        <SliderInfo dataList={vendor?.verticals} />
      )}

      {/* Other Images */}
      {vendor?.images?.length > 0 && <ImagesView dataList={vendor?.images} />}
    </PageLayout>
  );
};

export default VendorDetail;
